var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuistion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 21.999C17.5219 21.999 21.999 17.5219 21.999 11.999C21.999 6.47618 17.5219 1.99902 11.999 1.99902C6.47618 1.99902 1.99902 6.47618 1.99902 11.999C1.99902 17.5219 6.47618 21.999 11.999 21.999Z",
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08887 8.9991C9.32397 8.33077 9.78802 7.76721 10.3988 7.40824C11.0096 7.04926 11.7278 6.91804 12.426 7.03782C13.1243 7.15759 13.7577 7.52063 14.2139 8.06263C14.6702 8.60464 14.9199 9.29063 14.9189 9.9991C14.9189 11.9991 11.999 12.999 11.999 12.999",
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.249 13.999C11.249 14.4132 11.5848 14.749 11.999 14.749C12.4132 14.749 12.749 14.4132 12.749 13.999H11.249ZM11.249 12.999V13.999H12.749V12.999H11.249Z",
    fill: "#122C44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 16.999H12.009",
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuistion);
export default __webpack_public_path__ + "static/media/quistion.a223ad3572b0c4cb5e6c669af9ba2789.svg";
export { ForwardRef as ReactComponent };